<template>
  <div id="nav">
    <div class="top_nav">
      <div class="top_nav__overlay">
        <i class="mdi mdi-menu active" @click="$emit('open-sidebar')"></i>
        <!-- <i class="mdi mdi-magnify active"></i> -->
        <router-link :to="'/'" class="logo">
          <img src="@/assets/img/logo.svg" @click="back" />
        </router-link>

        <CoursesMenu />

        <NavbarSearch />

        <div class="buttons-block">
          <!-- <button class="lang">Eng</button> -->
          <button class="sign_in" @click="$emit('open-modal')">Войти</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CoursesMenu from '@/components/navbar/CoursesMenu'
import NavbarSearch from '@/components/navbar/NavbarSearch'

export default {
  components: {
    CoursesMenu,
    NavbarSearch
  },
  methods: {
    back() {
      if (this.$route.name === 'home') {
        return
      }
      this.$router.push('/')
    }
  }
}
</script>
